<div class="container-fluid mb-3 p-3 dashboard__header d-lg-none">

  <div class="row">
    <div class="col-3">
      <div class="client-menu client-menu-right">
    <button (click)="goToBook();" mat-icon-button>
        <mat-icon>chevron_left</mat-icon>
    </button>
</div>
    </div>
    <div class="col-6 d-flex align-items-center justify-content-center">
      <img class="img-fluid" src="../assets/Winning_Hands_Logo_Black-300x100.png">
    </div>
    <div class="col-3 justify-content-end d-flex">
      <button [matMenuTriggerFor]="userMenu" mat-button><mat-icon>menu</mat-icon></button>
      <mat-menu #userMenu="matMenu">
        <button (click)="goToBook();" mat-menu-item>
    <mat-icon>today</mat-icon>
    <span>Book a massage</span>
  </button>
  <button (click)="goToLogin();" mat-menu-item>
    <mat-icon>account_circle</mat-icon>
    <span>Therapist login</span>
  </button>
      </mat-menu>
    </div>
  </div>
</div>
<div class="container-fluid login-container body__container">
    <div class="row">
        <div class="col-lg-6 d-none d-lg-block px-0 login-container__background">
            <div class="row login-container__logo m-0 p-3">
                <div class="col-12">
                    <img src="../../../assets/Winning_Hands_Logo_Black-300x100.png">
                </div>
            </div>
        </div>
        <div class="col-lg-6 col-12 d-flex login-container__login-section p-lg-5">
            <div class="container p-lg-5">
                <div class="row">
                    <div class="col-12">
                        <h1>LOGIN</h1>
                    </div>
                </div>
                <div class="row">
                    <div class="col-12">
                        <p class="text-muted">Enter your login details below to get started</p>
                    </div>
                </div>
                @if (loginFormError){
                     <div class="row mb-4">
                    <div class="col-12">
                        <div class="card card__warning p-3">
                            <div class="row d-flex align-items-center justify-content-center">
                                <div class="col-auto pe-0 d-flex align-items-center">
                                    <mat-icon aria-hidden="false" fontIcon="error"></mat-icon>
                                </div>
                                <div class="col">
                                    <p class="mb-0">The username or password you have entered are incorrect. Please
                                        check and try again.
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                }
               


                <form [formGroup]="loginForm">
                    <div class="row mb-3">
                        <div class="col-12">
                            <mat-form-field class="w-100" appearance="outline" hideRequiredMarker="true">
                                <mat-label>USERNAME</mat-label>
                                <input formControlName="username" matInput placeholder="johnsmith">
                                <mat-icon matSuffix>person</mat-icon>

                                @if (loginForm.get('username')?.hasError('required')) {
                                <mat-error>Username is <strong>required</strong></mat-error>
                                }
                            </mat-form-field>
                        </div>
                    </div>

                    <div class="row mb-3">
                        <div class="col-12">
                            <mat-form-field class="w-100" appearance="outline" hideRequiredMarker="true">
                                <mat-label>PASSWORD</mat-label>
                                <input type="password" formControlName="password" matInput placeholder="password">
                                <mat-icon matSuffix>key</mat-icon>
                                @if (loginForm.get('password')?.hasError('required')) {
                                <mat-error>Password is <strong>required</strong></mat-error>
                                }
                            </mat-form-field>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-12">
                            <button (click)="loginUser();" class="w-100" mat-flat-button color="primary">LOG IN</button>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    </div>
</div>